function createCookie(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
} 

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}   

function eraseCookie(name) {
  createCookie(name, "", -1);
}

// if (readCookie("bg")) {
//   $("#MainContent").css(readCookie("bg"))
//   $("#MainContent").css("background-color", "#000");
//   console.log("readCookie", readCookie("bg"));
// }

// $(document).ready(function () {
//   $(".tabcontent-item").click(function () {
//     let bg = $(this).find(".image").attr("style");
//     createCookie("bg", bg, 1);
//     console.log("bg", bg);
//   });
// });   

if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function($) {
    $('body').scroll(function(){
      if($('body').scrollTop() > 65){
        $('.custom-sticky-header').addClass('custom-sticky');
        $('.essential_annoucement_bar_wrapper').addClass('hide-banner');
      }else{
        $('.custom-sticky-header').removeClass('custom-sticky');
        $('.essential_annoucement_bar_wrapper').removeClass('hide-banner');
      }
    });
  });
} else {
  console.error('jQuery is not loaded');
}